export function setFormatNumberToMoney(number){
    let dollarUSLocale = Intl.NumberFormat('en-US');
    return `$ ${dollarUSLocale.format(number)}`
}